import React from 'react'
import MobileHeaderLayout from '../MobileLayouts/MobileHeaderLayout'
import ComputerHeaderLayout from '../ComputerLayouts/ComputerHeaderLayout'
import TabletHeaderLayout from '../TabletLayouts/TabletHeaderLayout'
import { screenSize } from '../../../Common/Common'

export default function HeaderLayout () {
  const layouts = {
    Mobile: MobileHeaderLayout,
    Computer: ComputerHeaderLayout,
    Tablet: TabletHeaderLayout
  }

  const ResponsiveLayout = layouts[screenSize()]

  return (
    <ResponsiveLayout />
  )
}
